"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUDResource = exports.CursorDirection = void 0;
var tslib_1 = require("tslib");
/**
 *  @internal
 *  @module Resources
 */
var RestAPI_js_1 = require("../api/RestAPI.js");
var Resource_js_1 = require("./Resource.js");
var CursorDirection;
(function (CursorDirection) {
    CursorDirection["ASC"] = "asc";
    CursorDirection["DESC"] = "desc";
})(CursorDirection = exports.CursorDirection || (exports.CursorDirection = {}));
var CRUDResource = /** @class */ (function (_super) {
    tslib_1.__extends(CRUDResource, _super);
    function CRUDResource(api) {
        var _this = _super.call(this, api) || this;
        _this._routeBase = _this.constructor.routeBase;
        return _this;
    }
    CRUDResource.prototype._listRoute = function (required, requireAuth, acceptType, keyFormatter) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.GET, this._routeBase, required, requireAuth, acceptType, keyFormatter);
    };
    CRUDResource.prototype._createRoute = function (required, requireAuth, acceptType, keyFormatter) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.POST, this._routeBase, required, requireAuth, acceptType, keyFormatter);
    };
    CRUDResource.prototype._getRoute = function (required, requireAuth, acceptType, keyFormatter) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.GET, "".concat(this._routeBase, "/:id"), required, requireAuth, acceptType, keyFormatter);
    };
    CRUDResource.prototype._updateRoute = function (required, requireAuth, acceptType, keyFormatter) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.PATCH, "".concat(this._routeBase, "/:id"), required, requireAuth, acceptType, keyFormatter);
    };
    CRUDResource.prototype._deleteRoute = function (required, requireAuth, acceptType, keyFormatter) {
        return this.defineRoute(RestAPI_js_1.HTTPMethod.DELETE, "".concat(this._routeBase, "/:id"), required, requireAuth, acceptType, keyFormatter);
    };
    return CRUDResource;
}(Resource_js_1.Resource));
exports.CRUDResource = CRUDResource;
//# sourceMappingURL=CRUDResource.js.map